import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { GREEN, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import { localizeHelpCenterLink } from '../../../_config/utils.js';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import TenupActivationForm from '../../forms/Integrations/TenupActivationForm.jsx';
import { submit } from 'redux-form';


@connect(state => ({ language: state.settings.language, integrations: state.user.activeIntegration }))
class TenupSettingsOperationalSection extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      additionalInfo: null
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.TENUP_INTEGRATION));
    const additionalInfo = dispatch(UserActions.getIntegrationAdditionalInfo(SUBSCRIPTION_TYPES.TENUP_INTEGRATION));
    this.setState({ isActive, additionalInfo });
  }


  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const deactivationDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.TENUP_INTEGRATION));
      if (deactivationDTO && deactivationDTO.id) {
        await dispatch(UserActions.disableIntegration(deactivationDTO.id));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(UserActions.fetchCurrentActiveIntegrations());
        this.setState({ isActive: false });
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
          },
        }));
      } else {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
          },
        }));
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  onOpenActivationInfo() {
    const helpURL = localizeHelpCenterLink('activate-optix-integration');
    window.open(helpURL);
  }

  onGoBackToLogin() {
    this.setState({ resourceTypes: null, optixToken: null })
  }

  async onActivateTenupIntegration(activationData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    const { codeClub, allowAccessMinutesBefore, allowAccessMinutesAfter } = activationData;
    try {
      await dispatch(UserActions.activateTenupIntegration(codeClub, parseInt(allowAccessMinutesBefore || 0) || 0, parseInt(allowAccessMinutesAfter || 0) || 0));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: true });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { isActive, additionalInfo, resourceTypes } = this.state;
    const { dispatch } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="nexudus" src="/imgs/common/integrationLogos/tenup-logo.png" style={{ height: 70, alignSelf: 'center' }} />
        {isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            <MDButton
              title={<Entity key={isActive} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 0, marginTop: 10, width: '80%' }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
            <div style={{ width: '70%', margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <h4 style={{ textAlign: 'center', margin: 0, marginTop: 40, marginBottom: 10 }}><Entity style={{ fontWeight: 'bold' }} entity="activateTenupIntegrationTitle" /></h4>
              <h4 style={{ textAlign: 'center', margin: 0, marginBottom: 20 }}><Entity entity="activateTenupIntegrationDescription" data={{ integrationName: 'Ten\'Up' }}/></h4>
              <TenupActivationForm
                onSubmit={(data) => this.onActivateTenupIntegration(data)}
              />
              <MDButton
                title={<Entity key={isActive} entity="activate" />}
                titleStyle={{ marginTop: 0, fontSize: 13 }}
                backgroundColor={GREEN}
                containerStyle={{ margin: 0, margin: 'auto', marginTop: 20, width: '100%' }}
                onClick={() => dispatch(submit('TenupActivationForm'))}
              />
            </div>
          )}
        {/* <h5
          className="link-label"
          style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
          onClick={() => this.onOpenActivationInfo()}
        >
          <Entity entity="findOutMore" />
        </h5> */}
      </div>
    );
  }
}

export default TenupSettingsOperationalSection;
